(function(){
  "use strict";

  /* ===================================================================
     Real Shopify cart — replaces the old hardcoded PRODUCTS/cart array.
     Talks to the store's real /cart.js AJAX endpoints.
  =================================================================== */
  var NozzlCart = (function(){
    var itemsEl = document.getElementById('cart-items');
    var summaryEl = document.getElementById('cart-summary');
    var subtotalEl = document.getElementById('cart-subtotal');
    var countEl = document.getElementById('cart-count');
    var cartBtn = document.getElementById('cart-btn');

    function money(cents){
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + amount;
    }

    function render(cart){
      if(!itemsEl) return;
      countEl.hidden = cart.item_count === 0;
      countEl.textContent = cart.item_count;
      if(cart.item_count === 0){
        itemsEl.innerHTML = '<div class="cart-empty">' + (window.themeStrings.cartEmpty || 'Cart is empty') + '</div>';
        if(summaryEl){ summaryEl.hidden = true; }
        return;
      }
      if(summaryEl){ summaryEl.hidden = false; }
      var html = '';
      cart.items.forEach(function(item, idx){
        html +=
          '<div class="cart-row">' +
            '<div class="thumb">' + (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '') + '</div>' +
            '<div><h4>' + item.product_title + '</h4>' +
              '<div class="meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '') + '×' + item.quantity + '</div>' +
              '<button class="remove" type="button" data-remove-key="' + item.key + '">' + (window.themeStrings.cartRemove || 'Remove') + '</button>' +
            '</div>' +
            '<div class="row-price">' + money(item.final_line_price) + '</div>' +
          '</div>';
      });
      itemsEl.innerHTML = html;
      if(subtotalEl){ subtotalEl.textContent = money(cart.total_price); }
      itemsEl.querySelectorAll('[data-remove-key]').forEach(function(btn){
        btn.addEventListener('click', function(){ changeLine(btn.getAttribute('data-remove-key'), 0); });
      });
    }

    function refresh(){
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ render(cart); return cart; });
    }

    function add(variantId, quantity){
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function(r){ return r.json(); }).then(function(){
        return refresh();
      });
    }

    function changeLine(key, quantity){
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function(r){ return r.json(); }).then(function(cart){ render(cart); return cart; });
    }

    function pulseCartIcon(){
      if(!cartBtn) return;
      cartBtn.style.transform = 'scale(1.15)';
      setTimeout(function(){ cartBtn.style.transform = ''; }, 220);
    }

    return { refresh: refresh, add: add, changeLine: changeLine, pulse: pulseCartIcon };
  })();

  function openOverlay(el){ if(el){ el.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeOverlay(el){ if(el){ el.classList.remove('open'); document.body.style.overflow = ''; } }
  document.querySelectorAll('.overlay').forEach(function(ov){
    ov.querySelectorAll('[data-close]').forEach(function(btn){ btn.addEventListener('click', function(){ closeOverlay(ov); }); });
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ document.querySelectorAll('.overlay.open').forEach(function(ov){ closeOverlay(ov); }); }
  });

  var cartDrawer = document.getElementById('cart-drawer');
  var cartBtnEl = document.getElementById('cart-btn');
  if(cartBtnEl){ cartBtnEl.addEventListener('click', function(){ openOverlay(cartDrawer); }); }
  NozzlCart.refresh();

  /* ===================================================================
     Header search: liquid-glass bar + tracking "eyes" + predictive
     results (Prodotti / Categorie / Potrebbe interessarti).

     The "Potrebbe interessarti" group is NOT an AI search — it's a small
     curated synonym map below (INTEREST_MAP) matched against real
     collections embedded in snippets/search-panel.liquid. Extend the
     map and add the collection to that snippet if you want more terms
     covered; nothing here fabricates data that isn't really in the shop.
  =================================================================== */
  (function initSearch(){
    var toggle = document.getElementById('search-toggle');
    var panel = document.getElementById('search-panel');
    var siteHeader = document.querySelector('.site-header');
    var input = document.getElementById('search-input');
    var resultsBox = document.getElementById('search-results');
    var eyeLeft = document.getElementById('search-eye-left');
    var eyeRight = document.getElementById('search-eye-right');
    if(!toggle || !panel) return;

    function openSearch(){
      openOverlay(panel);
      if(siteHeader) siteHeader.classList.add('search-open');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function(){ input && input.focus(); }, 150);
    }
    function closeSearch(){
      closeOverlay(panel);
      if(siteHeader) siteHeader.classList.remove('search-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function(){
      panel.classList.contains('open') ? closeSearch() : openSearch();
    });
    panel.querySelectorAll('[data-search-close]').forEach(function(el){
      el.addEventListener('click', closeSearch);
    });
    panel.addEventListener('transitionend', function(){
      if(!panel.classList.contains('open') && siteHeader) siteHeader.classList.remove('search-open');
    });

    /* Googly eyes: pupils track the cursor anywhere on the page while
       the panel is open. Reduced-motion / touch devices keep them centered. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isTouch = 'ontouchstart' in window;
    if(eyeLeft && eyeRight && !reduceMotion && !isTouch){
      var pupilLeft = eyeLeft.querySelector('.search-pupil');
      var pupilRight = eyeRight.querySelector('.search-pupil');
      var ticking = false;
      function moveEye(eye, pupil, x, y){
        var r = eye.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var angle = Math.atan2(y - cy, x - cx);
        var dist = Math.min(4, Math.hypot(x - cx, y - cy) / 14);
        pupil.style.transform = 'translate(' + (Math.cos(angle) * dist) + 'px,' + (Math.sin(angle) * dist) + 'px)';
      }
      document.addEventListener('mousemove', function(e){
        if(!panel.classList.contains('open') || ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          moveEye(eyeLeft, pupilLeft, e.clientX, e.clientY);
          moveEye(eyeRight, pupilRight, e.clientX, e.clientY);
          ticking = false;
        });
      });
    }

    /* Curated interest → real-collection-handle map. Keys are matched as
       a simple substring against the query (case-insensitive, accent-safe). */
    var INTEREST_MAP = {
      'evento': ['allestimenti-1', 'allestimenti-bomboniere', 'business-premi-aziendali'],
      'eventi': ['allestimenti-1', 'allestimenti-bomboniere', 'business-premi-aziendali'],
      'matrimonio': ['allestimenti-bomboniere'],
      'nozze': ['allestimenti-bomboniere'],
      'bomboniere': ['allestimenti-bomboniere'],
      'regalo': ['living-decor', 'outdoor-decor', 'allestimenti-bomboniere'],
      'regali': ['living-decor', 'outdoor-decor', 'allestimenti-bomboniere'],
      'dono': ['living-decor', 'outdoor-decor'],
      'ufficio': ['business-organizer', 'business-desk-organizer', 'business-gadget-aziendali'],
      'lavoro': ['business-organizer', 'business-desk-organizer', 'business-gadget-aziendali'],
      'azienda': ['business-1', 'business-gadget-aziendali', 'business-premi-aziendali'],
      'aziendale': ['business-1', 'business-gadget-aziendali', 'business-premi-aziendali'],
      'premio': ['business-premi-aziendali'],
      'premi': ['business-premi-aziendali'],
      'casa': ['living-1'],
      'salotto': ['living-1', 'living-decor'],
      'giardino': ['outdoor-1'],
      'terrazzo': ['outdoor-1'],
      'balcone': ['outdoor-1']
    };
    var interestData = {};
    try {
      var interestScript = document.getElementById('search-interest-collections');
      if(interestScript) interestData = JSON.parse(interestScript.textContent);
    } catch(e){ interestData = {}; }

    function showGroup(name, html){
      var group = resultsBox.querySelector('[data-search-group="' + name + '"]');
      if(!group) return false;
      var list = group.querySelector('.search-group-list');
      if(html){ list.innerHTML = html; group.hidden = false; return true; }
      group.hidden = true; list.innerHTML = '';
      return false;
    }

    function productItemHtml(p){
      var img = p.image ? '<div class="search-result-thumb"><img src="' + p.image + '" alt="" loading="lazy"></div>' : '';
      var price = p.price ? '<span class="search-result-price">' + p.price + '</span>' : '';
      return '<a class="search-result-item" href="' + p.url + '">' + img +
        '<span class="search-result-text"><span class="search-result-title">' + p.title + '</span>' + price + '</span></a>';
    }
    function collectionItemHtml(c){
      var img = c.image ? '<div class="search-result-thumb"><img src="' + c.image + '" alt="" loading="lazy"></div>' : '';
      return '<a class="search-result-item" href="' + c.url + '">' + img +
        '<span class="search-result-text"><span class="search-result-title">' + c.title + '</span></span></a>';
    }

    var debounceTimer;
    if(input){
      input.addEventListener('input', function(){
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        if(q.length < 2){ resultsBox.hidden = true; return; }
        debounceTimer = setTimeout(function(){ runSearch(q); }, 250);
      });
    }

    function runSearch(query){
      var normalized = query.toLowerCase();

      // Interest layer — purely local, no request needed.
      var interestHandles = [];
      Object.keys(INTEREST_MAP).forEach(function(key){
        if(normalized.indexOf(key) !== -1){
          INTEREST_MAP[key].forEach(function(handle){
            if(interestHandles.indexOf(handle) === -1) interestHandles.push(handle);
          });
        }
      });
      var interestHtml = interestHandles
        .map(function(h){ return interestData[h]; })
        .filter(function(c){ return c && c.title; })
        .map(collectionItemHtml)
        .join('');
      var hasInterest = showGroup('interest', interestHtml);

      // Native Shopify predictive search for products + collections.
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last')
        .then(function(r){ return r.json(); })
        .then(function(data){
          var res = (data && data.resources && data.resources.results) || {};
          var products = res.products || [];
          var collections = res.collections || [];
          var productsHtml = products.map(function(p){
            var priceStr = p.price ? '€' + parseFloat(p.price).toFixed(2).replace('.', ',') : '';
            return productItemHtml({ title: p.title, url: p.url, image: p.featured_image ? p.featured_image.url : (p.image || ''), price: priceStr });
          }).join('');
          var collectionsHtml = collections.map(function(c){
            return collectionItemHtml({ title: c.title, url: c.url, image: c.featured_image ? c.featured_image.url : (c.image || '') });
          }).join('');
          var hasProducts = showGroup('products', productsHtml);
          var hasCollections = showGroup('collections', collectionsHtml);
          var empty = resultsBox.querySelector('.search-empty');
          var anyResult = hasProducts || hasCollections || hasInterest;
          if(empty) empty.hidden = anyResult;
          resultsBox.hidden = false;
        })
        .catch(function(){
          var empty = resultsBox.querySelector('.search-empty');
          if(empty) empty.hidden = hasInterest;
          resultsBox.hidden = false;
        });
    }
  })();

  /* Quick-add "+" buttons on product cards (single-variant products only —
     see snippets/product-card.liquid). */
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-quick-add]');
    if(!btn) return;
    e.preventDefault();
    NozzlCart.add(btn.getAttribute('data-variant-id'), 1).then(function(){ NozzlCart.pulse(); openOverlay(cartDrawer); });
  });

  /* ===================================================================
     Product page: real Shopify variant picker + AJAX add-to-cart.
     Called once per main-product.liquid instance via NozzlProduct.init().
  =================================================================== */
  window.NozzlProduct = {
    init: function(sectionId, product){
      var form = document.getElementById('ProductForm-' + sectionId);
      if(!form) return;
      var variantInput = document.getElementById('ProductVariantId-' + sectionId);
      var priceEl = document.getElementById('ProductPrice-' + sectionId);
      var img = document.getElementById('ProductImage-' + sectionId);
      var addBtn = document.getElementById('AddToCart-' + sectionId);
      var qtyEl = document.getElementById('Quantity-' + sectionId);
      var qtyInput = document.getElementById('QuantityInput-' + sectionId);
      var selected = product.options.map(function(){ return null; });

      // seed `selected` from the initially-rendered active chips
      form.querySelectorAll('[data-option-index].active').forEach(function(chip){
        selected[parseInt(chip.getAttribute('data-option-index'), 10)] = chip.getAttribute('data-value');
      });

      function findVariant(){
        return product.variants.filter(function(v){
          return selected.every(function(val, i){ return val === null || v.options[i] === val; });
        })[0];
      }

      function moneyFmt(cents){ return '€' + (cents/100).toFixed(2).replace('.', ','); }

      function updateUI(){
        var variant = findVariant();
        if(!variant) return;
        variantInput.value = variant.id;
        if(priceEl){
          if(variant.compare_at_price && variant.compare_at_price > variant.price){
            priceEl.innerHTML = '<span class="was">' + moneyFmt(variant.compare_at_price) + '</span><span>' + moneyFmt(variant.price) + '</span>';
          } else {
            priceEl.innerHTML = '<span>' + moneyFmt(variant.price) + '</span>';
          }
        }
        if(img && variant.featured_image){ img.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2'); }
        if(addBtn){
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? (window.themeStrings.addToCart || 'Add to cart') : (window.themeStrings.soldOut || 'Sold out');
        }
      }

      form.querySelectorAll('[data-option-index]').forEach(function(chip){
        chip.addEventListener('click', function(){
          var idx = parseInt(chip.getAttribute('data-option-index'), 10);
          var group = form.querySelector('[data-option-index="' + idx + '"]').parentElement;
          group.querySelectorAll('.chip,.swatch').forEach(function(c){ c.classList.remove('active','selected'); });
          chip.classList.add(chip.classList.contains('swatch') ? 'selected' : 'active');
          selected[idx] = chip.getAttribute('data-value');
          var labelB = group.parentElement.querySelector('.pd-block-label b');
          if(labelB){ labelB.textContent = chip.getAttribute('data-value'); }
          updateUI();
        });
      });

      var qty = 1;
      form.querySelectorAll('[data-step]').forEach(function(btn){
        btn.addEventListener('click', function(){
          qty = Math.max(1, qty + parseInt(btn.getAttribute('data-step'), 10));
          if(qtyEl){ qtyEl.textContent = qty; }
          if(qtyInput){ qtyInput.value = qty; }
        });
      });

      form.addEventListener('submit', function(e){
        e.preventDefault();
        if(addBtn && addBtn.disabled) return;
        NozzlCart.add(variantInput.value, qty).then(function(){ NozzlCart.pulse(); openOverlay(cartDrawer); });
      });
    }
  };

  /* ===================================================================
     Language switch pill (visual state only — the actual navigation is a
     real form submit to Shopify's localization endpoint, wired in header.liquid).
  =================================================================== */

  /* ===================================================================
     Mobile menu
  =================================================================== */
  var mobileMenu = document.getElementById('mobile-menu');
  var menuBtn = document.getElementById('menu-btn');
  var mobileClose = document.getElementById('mobile-close');
  function openMobileMenu(){ if(mobileMenu){ mobileMenu.classList.add('open'); menuBtn.setAttribute('aria-expanded','true'); } }
  function closeMobileMenu(){ if(mobileMenu){ mobileMenu.classList.remove('open'); menuBtn.setAttribute('aria-expanded','false'); } }
  if(menuBtn){ menuBtn.addEventListener('click', openMobileMenu); }
  if(mobileClose){ mobileClose.addEventListener('click', closeMobileMenu); }
  if(mobileMenu){ mobileMenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMobileMenu); }); }

  var mobileSearchBtn = document.getElementById('mobile-search-btn');
  if(mobileSearchBtn){
    mobileSearchBtn.addEventListener('click', function(){
      closeMobileMenu();
      var searchToggle = document.getElementById('search-toggle');
      if(searchToggle) setTimeout(function(){ searchToggle.click(); }, 350);
    });
  }

  /* Mobile nav accordion (SHOP/SERVIZI/BUSINESS/STUDIO + nested categories) */
  if(mobileMenu){
    mobileMenu.querySelectorAll('.mobile-nav-toggle').forEach(function(btn){
      btn.addEventListener('click', function(){
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var sub = btn.closest('.mobile-nav-row').nextElementSibling;
        if(!sub) return;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        sub.classList.toggle('open', !expanded);
      });
    });
  }

  /* ===================================================================
     In-page smooth scroll (laser page CTAs)
  =================================================================== */
  document.querySelectorAll('[data-scrollto]').forEach(function(el){
    el.addEventListener('click', function(){
      var target = document.getElementById(el.getAttribute('data-scrollto'));
      if(target){ target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'}); }
    });
  });

  /* ===================================================================
     Reveal on scroll — a direct scroll-position check rather than
     IntersectionObserver/rAF, both of which browsers can pause in
     backgrounded tabs and silently stall.
  =================================================================== */
  function checkReveals(){
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = document.querySelectorAll('.reveal:not(.in), .reveal-img:not(.in)');
    for(var i=0;i<els.length;i++){
      var r = els[i].getBoundingClientRect();
      if(r.top < vh - 60){
        els[i].classList.add('in');
        if(els[i].hasAttribute('data-floaty')){
          (function(el){ setTimeout(function(){ el.classList.add('float'); }, 1300); })(els[i]);
        }
      }
    }
  }
  window.addEventListener('scroll', checkReveals, {passive:true});
  window.addEventListener('resize', checkReveals);
  window.addEventListener('load', checkReveals);
  document.addEventListener('visibilitychange', checkReveals);

  /* ===================================================================
     Print badge (home page hero only — the logo "prints" as you scroll)
  =================================================================== */
  var printBadge = document.getElementById('print-badge');
  var pbClipRect = document.getElementById('pb-clip-rect');
  var pbPct = document.getElementById('print-badge-pct');
  var pbScanline = document.getElementById('pb-scanline');
  var PB_TOP = 385, PB_H = 310;
  function updatePrintBadge(){
    if(!printBadge) return;
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    // Snap to 100% once the user has reached (or nearly reached) the true
    // bottom of the page, regardless of the raw fraction below — this
    // covers lazy-loaded images/fonts shifting scrollHeight after the
    // last scroll event, which otherwise left the badge stuck under 100%.
    var atBottom = scrollable <= 0 || (window.scrollY + window.innerHeight) >= (doc.scrollHeight - 2);
    var progress = atBottom ? 1 : (scrollable > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollable)) : 0);
    var filledH = PB_H * progress;
    var y = PB_TOP + (PB_H - filledH);
    pbClipRect.setAttribute('y', y);
    pbClipRect.setAttribute('height', filledH);
    pbScanline.setAttribute('y1', y);
    pbScanline.setAttribute('y2', y);
    pbScanline.style.opacity = (progress > 0.01 && progress < 0.995) ? '0.5' : '0';
    pbPct.textContent = Math.round(progress * 100) + '%';
    printBadge.classList.toggle('complete', progress >= 1);
    // Stay hidden right at the top of the page — the hero's own CTA
    // buttons sit in that same bottom-left corner on narrow screens, and
    // showing "0%" before the visitor has scrolled at all isn't
    // meaningful anyway for a scroll-progress indicator.
    printBadge.classList.toggle('show', window.scrollY > 120);
  }
  if(printBadge){
    window.addEventListener('scroll', updatePrintBadge, {passive:true});
    window.addEventListener('resize', updatePrintBadge);
    // Recompute whenever the page's height changes for any reason
    // (lazy images finishing load, webfonts swapping in, dynamic
    // content) — a plain scroll/resize listener misses these and can
    // leave the badge stuck below 100% even once you're at the bottom.
    if(window.ResizeObserver){
      new ResizeObserver(updatePrintBadge).observe(document.body);
    }
    window.addEventListener('load', updatePrintBadge);
  }

  /* ===================================================================
     Custom cursor, filament trail, magnetic buttons, ambient parallax
     (pointer devices only)
  =================================================================== */
  var canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var cursorDot = document.getElementById('cursor-dot');
  var cursorRing = document.getElementById('cursor-ring');
  var mouse = {x:innerWidth/2,y:innerHeight/2};
  var ring = {x:mouse.x,y:mouse.y};
  if(canHover && cursorDot && cursorRing){
    document.documentElement.classList.add('has-cursor');
    window.addEventListener('mousemove', function(e){
      mouse.x = e.clientX; mouse.y = e.clientY;
      cursorDot.classList.add('show'); cursorRing.classList.add('show');
      cursorDot.style.transform = 'translate('+mouse.x+'px,'+mouse.y+'px) translate(-50%,-50%)';
    });
    document.addEventListener('mouseover', function(e){
      if(e.target.closest && e.target.closest('a,button,[data-magnetic]')){ cursorRing.classList.add('hover'); }
    });
    document.addEventListener('mouseout', function(e){
      if(e.target.closest && e.target.closest('a,button,[data-magnetic]')){ cursorRing.classList.remove('hover'); }
    });
    (function loop(){
      ring.x += (mouse.x - ring.x) * 0.18;
      ring.y += (mouse.y - ring.y) * 0.18;
      cursorRing.style.transform = 'translate('+ring.x+'px,'+ring.y+'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();

    var filamentCanvas = document.getElementById('filament-canvas');
    if(filamentCanvas && filamentCanvas.getContext){
      var fctx = filamentCanvas.getContext('2d');
      var trail = [];
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      function resizeFilament(){
        filamentCanvas.width = innerWidth * dpr;
        filamentCanvas.height = innerHeight * dpr;
        filamentCanvas.style.width = innerWidth + 'px';
        filamentCanvas.style.height = innerHeight + 'px';
        fctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      resizeFilament();
      window.addEventListener('resize', resizeFilament);

      function inkRGB(){
        var hex = getComputedStyle(document.documentElement).getPropertyValue('--ink').trim();
        var h = hex.replace('#', '');
        if(h.length === 3){ h = h.split('').map(function(c){ return c + c; }).join(''); }
        var r = parseInt(h.substr(0,2),16), g = parseInt(h.substr(2,2),16), b = parseInt(h.substr(4,2),16);
        return isNaN(r) ? '20,20,20' : (r + ',' + g + ',' + b);
      }
      var inkColor = inkRGB();
      if(window.MutationObserver){
        new MutationObserver(function(){ inkColor = inkRGB(); })
          .observe(document.documentElement, {attributes:true, attributeFilter:['data-theme']});
      }

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(!reduceMotion){
        window.addEventListener('mousemove', function(e){
          trail.push({x:e.clientX, y:e.clientY, t:performance.now()});
          if(trail.length > 40){ trail.shift(); }
        });
        (function drawFilament(){
          var now = performance.now();
          trail = trail.filter(function(p){ return now - p.t < 650; });
          fctx.clearRect(0, 0, innerWidth, innerHeight);
          for(var i=1;i<trail.length;i++){
            var p0 = trail[i-1], p1 = trail[i];
            var age = (now - p1.t) / 650;
            var alpha = Math.max(0, (1-age) * 0.5);
            var w = Math.max(0.6, (1-age) * 5);
            fctx.beginPath();
            fctx.moveTo(p0.x, p0.y);
            fctx.lineTo(p1.x, p1.y);
            fctx.strokeStyle = 'rgba(' + inkColor + ',' + alpha + ')';
            fctx.lineWidth = w;
            fctx.lineCap = 'round';
            fctx.stroke();
          }
          requestAnimationFrame(drawFilament);
        })();
      }
    }

    var parallaxEls = document.querySelectorAll('[data-parallax]');
    if(parallaxEls.length){
      var pTargetX = 0, pTargetY = 0, pmx = 0, pmy = 0;
      window.addEventListener('mousemove', function(e){
        pTargetX = (e.clientX / innerWidth - 0.5) * 2;
        pTargetY = (e.clientY / innerHeight - 0.5) * 2;
      });
      (function ploop(){
        pmx += (pTargetX - pmx) * 0.055;
        pmy += (pTargetY - pmy) * 0.055;
        parallaxEls.forEach(function(el){
          var depth = parseFloat(el.getAttribute('data-parallax')) || 10;
          el.style.transform = 'translate(' + (pmx*depth) + 'px,' + (pmy*depth*0.6) + 'px)';
        });
        requestAnimationFrame(ploop);
      })();
    }
  }
  function initMagnetic(list){
    if(!canHover) return;
    (list || document.querySelectorAll('[data-magnetic]')).forEach(function(el){
      if(el.__magnetic) return;
      el.__magnetic = true;
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var relX = e.clientX - (r.left + r.width/2);
        var relY = e.clientY - (r.top + r.height/2);
        el.style.transform = 'translate('+(relX*0.25)+'px,'+(relY*0.3)+'px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  }

  /* ===================================================================
     Laser page: card rotation, colour picker, live engraving + sparks.
     Supports one or more laser-engraving sections on the same page,
     each identified by its own {{ section.id }} suffix.
  =================================================================== */
  document.querySelectorAll('[id^="metal-card-"]').forEach(function(metalCard){
    var sid = metalCard.id.replace('metal-card-', '');
    var cardStage = metalCard.closest('.card-stage');
    var cardRotY = 0, tiltRX = 0, tiltRY = 0;
    function renderCardTransform(){
      var scaling = (tiltRX || tiltRY) ? 1.02 : 1;
      metalCard.style.transform = 'rotateY(' + (cardRotY + tiltRY) + 'deg) rotateX(' + tiltRX + 'deg) scale(' + scaling + ')';
    }
    var arrowLeft = document.getElementById('card-arrow-left-' + sid);
    var arrowRight = document.getElementById('card-arrow-right-' + sid);
    if(arrowLeft){ arrowLeft.addEventListener('click', function(){ cardRotY -= 180; renderCardTransform(); }); }
    if(arrowRight){ arrowRight.addEventListener('click', function(){ cardRotY += 180; renderCardTransform(); }); }

    var picker = document.querySelector('[data-card-color-picker="metal-card-' + sid + '"]');
    if(picker){
      picker.querySelectorAll('.card-color-swatch').forEach(function(sw){
        sw.addEventListener('click', function(){
          picker.querySelectorAll('.card-color-swatch').forEach(function(s){ s.classList.remove('active'); });
          sw.classList.add('active');
          metalCard.setAttribute('data-color', sw.getAttribute('data-cardcolor'));
        });
      });
    }

    if(canHover && cardStage){
      var laserDot = document.getElementById('laser-dot-' + sid);
      var engraveCanvas = document.getElementById('engrave-canvas-' + sid);
      var ectx = null, ECW = 640, ECH = 404, lastEx = null, lastEy = null;
      if(engraveCanvas && engraveCanvas.getContext){
        ectx = engraveCanvas.getContext('2d');
        engraveCanvas.width = ECW;
        engraveCanvas.height = ECH;
      }
      var sparkCanvas = document.getElementById('spark-canvas-' + sid);
      var sctx = null, sparks = [];
      if(sparkCanvas && sparkCanvas.getContext){
        sctx = sparkCanvas.getContext('2d');
        sparkCanvas.width = ECW;
        sparkCanvas.height = ECH;
      }
      function spawnSparks(x, y){
        var n = 1 + Math.floor(Math.random()*2);
        for(var i=0;i<n;i++){
          var angle = Math.random()*Math.PI*2;
          var speed = 0.5 + Math.random()*1.6;
          sparks.push({ x:x, y:y, vx:Math.cos(angle)*speed, vy:Math.sin(angle)*speed - 0.5, life:0, maxLife:220 + Math.random()*260, size:.8 + Math.random()*1.2 });
        }
      }
      (function sparkLoop(){
        if(sctx){
          sctx.clearRect(0, 0, ECW, ECH);
          sparks = sparks.filter(function(p){
            p.life += 16;
            if(p.life > p.maxLife) return false;
            p.x += p.vx; p.y += p.vy; p.vy += 0.045;
            var t = 1 - p.life/p.maxLife;
            sctx.globalAlpha = t;
            sctx.fillStyle = '#CFFFE0';
            sctx.beginPath();
            sctx.arc(p.x, p.y, Math.max(.4, p.size*t), 0, Math.PI*2);
            sctx.fill();
            return true;
          });
          sctx.globalAlpha = 1;
        }
        requestAnimationFrame(sparkLoop);
      })();
      function burn(ex, ey){
        if(!ectx) return;
        var pts = [[ex,ey]];
        if(lastEx !== null){
          var dx = ex-lastEx, dy = ey-lastEy;
          var dist = Math.sqrt(dx*dx+dy*dy);
          var steps = Math.min(24, Math.ceil(dist/4));
          pts = [];
          for(var s=1;s<=steps;s++){ pts.push([lastEx + dx*(s/steps), lastEy + dy*(s/steps)]); }
        }
        pts.forEach(function(pt){
          var grd = ectx.createRadialGradient(pt[0],pt[1],0,pt[0],pt[1],6);
          grd.addColorStop(0, 'rgba(15,13,11,.5)');
          grd.addColorStop(.7, 'rgba(15,13,11,.18)');
          grd.addColorStop(1, 'rgba(15,13,11,0)');
          ectx.fillStyle = grd;
          ectx.beginPath();
          ectx.arc(pt[0], pt[1], 6, 0, Math.PI*2);
          ectx.fill();
          if(Math.random() < 0.4){ spawnSparks(pt[0], pt[1]); }
        });
        lastEx = ex; lastEy = ey;
      }
      function wipeEngrave(){
        if(!ectx || !engraveCanvas) return;
        engraveCanvas.style.transition = 'opacity .45s ease';
        engraveCanvas.style.opacity = '0';
        setTimeout(function(){ ectx.clearRect(0, 0, ECW, ECH); engraveCanvas.style.opacity = '1'; }, 450);
      }
      setInterval(wipeEngrave, 5000);

      cardStage.addEventListener('mousemove', function(e){
        var r = metalCard.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        tiltRX = (0.5 - py) * 14;
        tiltRY = (px - 0.5) * 16;
        renderCardTransform();
        metalCard.style.setProperty('--mx', (px*100)+'%');
        metalCard.style.setProperty('--my', (py*100)+'%');
        if(px >= 0 && px <= 1 && py >= 0 && py <= 1 && Math.abs(cardRotY % 360) < 90){
          burn(px*ECW, py*ECH);
          if(laserDot){ laserDot.style.left = (px*100)+'%'; laserDot.style.top = (py*100)+'%'; laserDot.classList.add('show'); }
        } else {
          lastEx = null; lastEy = null;
          if(laserDot){ laserDot.classList.remove('show'); }
        }
      });
      cardStage.addEventListener('mouseleave', function(){
        tiltRX = 0; tiltRY = 0;
        renderCardTransform();
        metalCard.style.removeProperty('--mx');
        metalCard.style.removeProperty('--my');
        lastEx = null; lastEy = null;
        if(laserDot){ laserDot.classList.remove('show'); }
      });
    }
  });

  /* Live card preview: any form field carrying data-live-preview="targetId"
     updates that element's text as the merchant's customer types. */
  document.querySelectorAll('[data-live-preview]').forEach(function(field){
    var target = document.getElementById(field.getAttribute('data-live-preview'));
    if(!target) return;
    var defaultText = target.textContent;
    var upper = field.getAttribute('data-live-preview-transform') === 'upper';
    var evt = field.tagName === 'SELECT' ? 'change' : 'input';
    field.addEventListener(evt, function(){
      var val = field.tagName === 'SELECT' ? (field.value ? field.options[field.selectedIndex].textContent : '') : field.value;
      target.textContent = val ? (upper ? val.toUpperCase() : val.slice(0, 46)) : defaultText;
    });
  });

  /* ===================================================================
     Hero background parallax (scroll)
  =================================================================== */
  var heroImg = document.getElementById('hero-img');
  function heroParallax(){
    if(!heroImg) return;
    var y = window.scrollY || 0;
    if(y < 900){ heroImg.style.transform = 'translateY(' + (y*0.18) + 'px) scale(1.02)'; }
  }
  window.addEventListener('scroll', heroParallax, {passive:true});

  /* ===================================================================
     Collection page: fluid parallax gradient
  =================================================================== */
  var fluidGradient = document.getElementById('fluid-gradient');
  function updateFluidParallax(){
    if(!fluidGradient) return;
    var rect = fluidGradient.closest('section').getBoundingClientRect();
    fluidGradient.style.transform = 'translateY(' + (rect.top * 0.12) + 'px)';
  }
  if(fluidGradient){
    window.addEventListener('scroll', updateFluidParallax, {passive:true});
    window.addEventListener('resize', updateFluidParallax);
    updateFluidParallax();
  }

  /* ===================================================================
     Customer address forms: country -> province selector
     (mirrors Shopify's classic Shopify.CountryProvinceSelector, built
     from the data-provinces JSON attribute on each option produced by
     the all_country_option_tags filter)
  =================================================================== */
  function initCountryProvinceSelectors(){
    var countrySelects = document.querySelectorAll('[data-address-country-select]');
    countrySelects.forEach(function(countrySelect){
      var container = countrySelect.closest('form') || document;
      var provinceSelect = container.querySelector('[data-address-province-container] select');
      if(!provinceSelect) return;

      function populate(){
        var opt = countrySelect.options[countrySelect.selectedIndex];
        var raw = opt ? opt.getAttribute('data-provinces') : null;
        var provinces = [];
        try { provinces = raw ? JSON.parse(raw) : []; } catch(e){ provinces = []; }
        provinceSelect.innerHTML = '';
        var wrap = provinceSelect.closest('[data-address-province-container]');
        if(!provinces.length){
          if(wrap) wrap.style.display = 'none';
          return;
        }
        if(wrap) wrap.style.display = '';
        provinces.forEach(function(pair){
          var o = document.createElement('option');
          o.value = pair[0];
          o.textContent = pair[1];
          provinceSelect.appendChild(o);
        });
      }

      var defaultCountry = countrySelect.getAttribute('data-default-country');
      if(defaultCountry){
        for(var i=0;i<countrySelect.options.length;i++){
          if(countrySelect.options[i].value === defaultCountry){ countrySelect.selectedIndex = i; break; }
        }
      }
      populate();
      countrySelect.addEventListener('change', populate);
    });
  }

  /* ===================================================================
     Business page hero: cursor-following spotlight glow
  =================================================================== */
  (function initBizHeroSpotlight(){
    var heroes = document.querySelectorAll('.biz-hero');
    if(!heroes.length) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if('ontouchstart' in window) return;
    heroes.forEach(function(hero){
      hero.addEventListener('mousemove', function(e){
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--sx', ((e.clientX - r.left) / r.width * 100) + '%');
        hero.style.setProperty('--sy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  })();

  /* ===================================================================
     Init
  =================================================================== */
  initCountryProvinceSelectors();
  checkReveals();
  updatePrintBadge();
  initMagnetic();
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.documentElement.classList.add('loaded'); }); });
  setTimeout(function(){ document.documentElement.classList.add('loaded'); }, 500);
})();
